// AdminOne FoodRx Intelligence Dashboard — aggregate only.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL } from "@/api/connectorPackClient";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
function token() { try { return localStorage.getItem("carelogix_adminone_token") || ""; } catch (_) { return ""; } }
async function api(path) {
  const tok = token();
  const res = await fetch(`${BACKEND}${path}`, { headers: tok ? { Authorization: `Bearer ${tok}` } : {} });
  if (!res.ok) throw new Error(`${res.status}`);
  return res.json();
}

export default function AdminOneFoodRxIntelligence() {
  const [data, setData] = useState(null);
  const [err, setErr]   = useState("");
  const load = useCallback(async () => {
    try { setData(await api("/api/adminone/foodrx-intelligence/dashboard")); }
    catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div style={SHELL.page} data-testid="adminone-foodrx-page">
      <h2 style={SHELL.h2}>AdminOne · ORACLE FoodRx™ Intelligence (Aggregate)</h2>
      <h1 style={SHELL.h1}>FoodRx Intelligence Dashboard</h1>
      {err && <div style={SHELL.err}>{err}</div>}
      <p style={SHELL.dim}>
        Aggregate trends only. Individual sensitive nutrition data is never exposed without consent.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14, marginTop: 16 }}>
        {[
          ["Active FoodRx members",        data?.active_foodrx_members ?? 0],
          ["Meal adherence trend",         data?.meal_adherence_trend ?? "—"],
          ["Hydration trend",              data?.hydration_trend ?? "—"],
          ["Med-food alert count",         data?.medication_food_alert_count ?? 0],
          ["Food trigger reports",         data?.food_trigger_reports ?? 0],
          ["Executive report status",      data?.executive_report_status ?? "—"],
          ["High-risk interaction alerts", data?.high_risk_interaction_alerts ?? 0],
          ["Weekly engagement",            data?.weekly_engagement ?? "—"],
          ["Reminder completion",          data?.reminder_completion ?? "—"],
          ["LifeCommand connection",       data?.lifecommand_connection ?? "—"],
        ].map(([label, value]) => (
          <div key={label} style={SHELL.panel} data-testid={`foodrx-kpi-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <div style={SHELL.h2}>{label}</div>
            <div style={{ ...SHELL.h1, fontSize: 24, marginTop: 4 }}>{String(value)}</div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 18, padding: 14, background: "rgba(229,162,58,0.08)", border: "1px solid #E5A23A", borderRadius: 10, fontSize: 12.5 }}>
        <strong style={{ color: "#E5A23A" }}>Compliance:</strong> {data?.privacy_note || "Aggregate trends only. No individual data exposed without consent."}
      </div>
    </div>
  );
}
